import type { TFunction } from "i18next";

import lowerCaseFirstLetter from "@core/utils/lowerCaseFirstLetter";

export default function getPromptNameFromPromptId(t: TFunction, promptId: string) {
    return t(`recognitionPrompts.${lowerCaseFirstLetter(promptId)}`);
}